import * as React from 'react';
import clsx from 'clsx';

import {TileButton as TileButtonBase} from 'common/onboarding/components/tile-button';

import styles from './tile-button.module.styl';

// Slight variation of TileButton from iron/common/onboarding/components/tile-button/index.tsx
export const TileButton = (props) => {
  const {className, ...rest} = props;
  return <TileButtonBase className={clsx(props.className, styles.tileButtonShadow)} {...rest} />;
};
